import port1 from '../img/portImages/img1.png';
import port2 from '../img/portImages/img2.png';
import port3 from '../img/portImages/img3.png';

const portfolios = [
    {
        id: 1,
        category: 'Animation',
        link1: 'https://camera-shop-9fa14.web.app/',
        link2: 'https://github.com/AyyubIqbal/Camera-Shop',
        icon1: 'G',
        icon2: 'Y',
        image: port1,
        title: 'Autodesk Maya'
    },
    {
        id: 2,
        category: 'Python',
        link1: 'https://vetcare-helth-assignment.web.app/',
        link2: 'https://github.com/AyyubIqbal/vetcare-health',
        icon1: 'G',
        icon2: 'Y',
        image: port2,
        title: 'Python Web Scrapping'
    },
    {
        id: 3,
        category: 'Animation',
        link1: 'https://assignment-11-tour-plan.web.app/',
        link2: 'https://github.com/AyyubIqbal/travelGuru',
        icon1: 'G',
        icon2: 'Y',
        image: port3,
        title: 'Autodesk Maya'
    }
]

export default portfolios;